import { render, staticRenderFns } from "./aboutus-lt.vue?vue&type=template&id=2644b4ed&scoped=true&"
import script from "./aboutus-lt.vue?vue&type=script&lang=js&"
export * from "./aboutus-lt.vue?vue&type=script&lang=js&"
import style0 from "./aboutus-lt.vue?vue&type=style&index=0&id=2644b4ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644b4ed",
  null
  
)

export default component.exports